import { icons } from "lucide-react";
import { CTABanner, ZigZagSection } from "../components/ui/UtilsLayout";
import { imagePath } from "../utils/imagePath";


export default function UniversityAlliance() {
  const partnersData = [
    {
      icon: imagePath?.manipalLogo,
    },
    {
      icon: imagePath?.SreeNidhiLogo,
    },
  ];

  return (
    <div className="w-full flex flex-col gap-8 md:gap-12 lg:gap-16 mt-16 md:mt-24 lg:mt-32 px-4 md:px-8 lg:px-16 bg-[#121316]">
      {/* Hero Section */}
      <div className="text-center max-w-5xl mx-auto space-y-3 md:space-y-4 pt-6 md:pt-8 z-20">
        <h1 className="text-xl md:text-3xl lg:text-4xl font-bold bg-[#DDDCDC] bg-clip-text text-transparent leading-tight font-jakarta px-2">
          Building the Future of Spatial Computing With Leading Academic
          Institutions
        </h1>
        <p className="text-sm md:text-base lg:text-[16px] text-[#A7A7AA] leading-relaxed px-2">
          Spatial Grid collaborates with top universities to advance research,
          accelerate innovation, and nurture the next generation of XR and
          Spatial AI talent. Through strategic alliances and long-term MoUs, we
          work closely with faculty, researchers, and students to push the
          boundaries of immersive technology.
        </p>
      </div>

      {/* Our Academic Partners Title */}
      <div className="flex items-center justify-center mt-4 md:mt-6">
        <h1 className="text-[#D8D8D8] text-lg md:text-xl lg:text-2xl font-bold">
          Our Academic Partners
        </h1>
      </div>

      {/* Decorative Image - Desktop only */}
      <div className="hidden lg:block absolute -top-[200px] right-[105px] lg:right-[0px]">
        <img
          className="h-[400px] md:h-[600px] lg:h-[800px] w-auto object-contain"
          src={imagePath?.reaearch1}
          alt="Grid AI"
        />
      </div>

      {/* Partner Logos */}
      <div className="flex flex-wrap justify-center gap-4 md:gap-6 max-w-5xl mx-auto z-[9]">
        {partnersData.map((item, idx) => (
          <div
            key={idx}
            className="flex justify-center items-center w-32 h-32 md:w-40 md:h-40 lg:w-44 lg:h-44 
                 bg-white rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl 
                 transition-all duration-300 overflow-hidden cursor-pointer"
          >
            <img
              src={item.icon}
              alt="icon"
              className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 object-contain mx-auto"
            />
          </div>
        ))}
      </div>

      {/* Decorative Image - Desktop only */}
      <div className="hidden lg:block absolute top-[550px] left-0">
        <img
          className="h-[100px] md:h-[330px] w-auto object-contain"
          src={imagePath?.reaearch2}
          alt="Grid AI"
        />
      </div>

      {/* MINDLabs Section */}
      <div className="w-screen relative left-[50%] right-[50%] -mx-[50vw] bg-[#1E1E22] py-6 md:py-16 lg:py-16 mt-8 md:mt-12 lg:mt-16 ">
        <div className="max-w-[1350px] mx-auto px-4 md:px-8 lg:px-16">
          {/* Mobile & Tablet: Column Layout */}
          <div className="flex flex-col gap-6 md:gap-8 lg:hidden">
            {/* TEXT SECTION - Mobile & Tablet */}
            <div className="space-y-4 md:space-y-5">
              <div className="flex  md:flex-row gap-3 md:gap-4 items-center md:items-center">
                <img
                  src={imagePath?.mindsLab}
                  alt="icon"
                  className="w-20 h-20 md:w-24 md:h-24 rounded-md"
                />
                <div className="flex flex-col gap-2 md:gap-3">
                  <h3 className="text-xl md:text-2xl font-semibold text-white">
                    MINDLabs
                  </h3>
                  <div className="flex flex-wrap gap-2 md:gap-3 text-sm md:text-base text-white font-medium">
                    {['Machine', 'Innovation', 'Neuro', 'Digital'].map(
                      (word, i) => (
                        <span
                          key={i}
                          className="pr-2 md:pr-3 border-r border-gray-300 last:border-none"
                        >
                          {word}
                        </span>
                      )
                    )}
                  </div>
                </div>
              </div>

              <p className="text-sm md:text-base text-white leading-relaxed">
                <span className="text-[#D1D1D1] font-bold text-base md:text-lg">
                  Spatial Grid's collaborative innovation hub
                </span>
                <br />
                MindLabs, established <span className="mr-2">with</span>
                <span className="font-bold text-white text-base md:text-lg">
                  Manipal Institute of Technology,
                </span>{' '}
                is an immersive research and experimentation center dedicated
                to:
              </p>

              <ul className="list-disc list-inside text-[#D1D1D1] space-y-1 text-sm md:text-base">
                <li>Human–computer interaction studies</li>
                <li>Behavioral research using XR environments</li>
                <li>AI-driven simulations and learning systems</li>
                <li>Student and faculty-led innovation projects</li>
                <li>Industry–academia knowledge exchange</li>
              </ul>

              <p className="text-[#D1D1D1] text-sm md:text-base">
                MindLabs serves as the blueprint for future Spatial Grid
                innovation centers across universities.
              </p>
            </div>

            {/* IMAGE SECTION - Mobile & Tablet */}
            <div className="w-full">
              <img
                src={imagePath?.mindLabsSection}
                className="w-full h-auto object-cover rounded-xl md:rounded-2xl shadow-xl"
                alt="MINDLabs section"
              />
            </div>
          </div>

          {/* Desktop: Side-by-side layout */}
          <div className="hidden lg:grid lg:grid-cols-2 items-start gap-10">
            {/* TEXT SECTION - Desktop */}
            <div className="space-y-2 md:space-y-4 lg:space-y-7">
              <div className="flex flex-row gap-4 items-center">
                <img
                  src={imagePath?.mindsLab}
                  alt="icon"
                  className="w-28 h-28 rounded-md"
                />
                <div className="flex flex-col gap-2 ">
                  <h3 className="text-2xl font-semibold text-white">
                    MINDLabs
                  </h3>
                  <div className="flex flex-wrap gap-3 text-[18px] text-white font-medium">
                    {['Machine', 'Innovation', 'Neuro', 'Digital'].map(
                      (word, i) => (
                        <span
                          key={i}
                          className="pr-3 border-r border-gray-300 last:border-none"
                        >
                          {word}
                        </span>
                      )
                    )}
                  </div>
                </div>
              </div>

              <p className="text-lg text-white leading-relaxed">
                <span className="text-[#D1D1D1] font-bold text-[20px]">
                  Spatial Grid's collaborative innovation hub
                </span>
                <br />
                MindLabs, established <span className="mr-2">with</span>
                <span className="font-bold text-white text-[20px]">
                  Manipal Institute of Technology,
                </span>{' '}
                is an immersive research and experimentation center dedicated
                to:
              </p>

              <ul className="list-disc list-inside text-[#D1D1D1] space-y-1 text-base">
                <li>Human–computer interaction studies</li>
                <li>Behavioral research using XR environments</li>
                <li>AI-driven simulations and learning systems</li>
                <li>Student and faculty-led innovation projects</li>
                <li>Industry–academia knowledge exchange</li>
              </ul>

              <p className="text-[#D1D1D1] text-base">
                MindLabs serves as the blueprint for future Spatial Grid
                innovation centers across universities.
              </p>
            </div>

            {/* IMAGE SECTION - Desktop */}
            <div className="relative group flex justify-center min-h-[500px]">
              <img
                src={imagePath?.mindLabsSection}
                className="absolute inset-0 w-full h-full object-cover rounded-2xl shadow-xl"
                alt="section"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Research Title Section */}
      <div className="text-center max-w-3xl mx-auto space-y-3 md:space-y-4 px-4">
        <h2 className="text-lg md:text-2xl lg:text-3xl font-bold text-[#ffffff]">
          Research. Talent. Innovation. Together.
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[#717173] font-medium leading-relaxed">
          Our university alliances deliver impact on three fronts
        </p>
      </div>

      {/* ZigZag Sections Container */}
      {/* ZigZag Sections Container - REMOVE any padding/margin constraints */}
      <div className="relative w-screen left-[50%] right-[50%] -mx-[50vw] flex flex-col gap-8 md:gap-6 lg:gap-12">
        {/* Section 1 */}
        <ZigZagSection
          number="1."
          title="Joint Research & Knowledge Advancement"
          description="We collaborate with faculty and research groups to explore cutting-edge themes across XR, Spatial AI, simulation, digital twins, and Agentic AI."
          subTitle="Our research ecosystem includes:"
          listItems={[
            'Co-authored papers in XR, HCI, AI-driven simulation, and spatial analytics.',
            'Shared research labs like MindLabs for experimentation, behavioral studies, and prototyping.',
            'Grant-backed projects focused on industry challenges in healthcare, manufacturing, real estate, space systems, and safety.',
            'Joint exploration of emerging fields such as autonomous agents, spatial sensing, remote operations, and immersive learning frameworks.',
            'Access to real-world industry datasets that enable richer academic research and applied experimentation.',
          ]}
          bottomText="Through these collaborations, universities gain industry relevance while Spatial Grid benefits from rigorous scientific inquiry."
          image={imagePath?.jointResearch}
          reverse={false}
        />

        {/* Section 2 */}
        <ZigZagSection
          number="2."
          title="Talent Development & Skill Acceleration"
          description="We bridge academic learning with hands-on industry experience. Students gain access to:"
          listItems={[
            'Internships and research assistantships on active XR/AI projects.',
            'Curriculum-aligned workshops in Unity, Unreal, Spatial AI, digital twin pipelines, and multimodal interaction design.',
            'Hackathons and innovation sprints to foster rapid prototyping and problem-solving.',
            'Mentorship from Spatial Grid engineers, researchers, and designers.',
            'Campus hiring and direct recruitment into XR development, AI engineering, simulation design, and business roles.',
            'Portfolio-building opportunities through real deployments, POCs, and published research.',
          ]}
          bottomText="Students gain hands-on experience with industry tools and workflows, preparing them for careers in immersive tech and advanced AI systems."
          image={imagePath?.DevelopmentSkill}
          reverse={true}
        />

        {/* Section 3 */}
        <ZigZagSection
          number="3."
          title="Industry-Aligned Innovation & Real-World Impact"
          description="Our partnerships bridge academic creativity with enterprise problem-solving. Together, we co-create solutions that move beyond labs and into the real world."
          subTitle="Key areas of innovation include:"
          listItems={[
            'Immersive training modules for Pharma, Manufacturing, Mining, Space, Defence, Healthcare and many more industries.',
            'Digital twin systems for engineering education, operations training, and predictive simulation.',
            'Interdisciplinary projects combining design, engineering, psychology, and human factors research.',
            'Innovation labs and centers of excellence like MindLabs that serve as hubs for continuous experimentation.',
            'Showcase opportunities at conclaves, research symposiums, and industry–academia demos.',
          ]}
          bottomText="These initiatives help universities produce industry-ready innovations while enabling Spatial Grid to test, refine, and deploy new technologies with academic rigor."
          image={imagePath?.industryInovation}
          reverse={false}
        />
      </div>

      {/* Decorative Image - Desktop only */}
      <div className="relative">
        <div className="hidden lg:block absolute -bottom-14 -right-16">
          <img
            className="h-[200px] md:h-[600px] lg:h-[900px] w-auto object-contain"
            src={imagePath?.research3}
            alt="Grid AI"
          />
        </div>
      </div>

      {/* CTA Banner */}
      <section className="w-full mx-auto px-4 md:px-6 lg:px-8 relative bottom-8 md:bottom-12 lg:bottom-16 max-w-[1300px]">
        <CTABanner
          welcomeText="Empowering the Next Generation of Spatial Computing Pioneers"
          description={
            <>
              At Spatial Grid, we believe the future of immersive technology
              thrives at the intersection of academia and industry. By working
              together, we create opportunities for breakthrough research,
              transformative learning, & meaningful careers. To explore a
              partnership or begin a collaboration, reach out to us at:{' '}
              <a
                href="mailto:info@spatialgrid.ai"
                className="text-blue-400 underline hover:text-blue-500"
              >
                info@spatialgrid.ai
              </a>
              .
            </>
          }
          buttonText="Contact Us"
          navigateTo="/contact-us"
        />
      </section>
    </div>
  );
}
